import * as React from 'react'

const defaultSize = {
  x: 16,
  y: 16,
}

interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const Fixed: React.FCC<IProps> = ({ size = defaultSize, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M2 14C10 14 6 2 14 2"
      stroke="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
      strokeDasharray="2 1"
    />
  </svg>
)
